import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-me-refeicao',
  templateUrl: './me-refeicao.component.html',
  styleUrls: ['./me-refeicao.component.css']
})
export class MeRefeicaoComponent implements OnInit {
  existeTreino: boolean = false;
  hideCL: boolean = false;
  idRefeicao: any = 0;
  numDS: any = 0;
  numDM: any = 0;
  meuIdDieta: any = 0;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.hideCL = true;
    this.existeTreino = true;
    this.numDS = +this.route.snapshot.paramMap.get('diadasemana');
    this.meuIdDieta = this.route.snapshot.paramMap.get('iddieta');
    this.idRefeicao = +this.route.snapshot.paramMap.get('idrefeicao');
    this.numDM = +this.route.snapshot.paramMap.get('diadomes');
    this.montarListaTreino();
    console.log(this.tmaService.qPagina);
  }

  montarListaTreino() :void{
    
  }

  voltar() :void{
    if(this.tmaService.qPagina === "cardapio"){
      this.router.navigate(['me/cardapio/' + this.meuIdDieta + "/" + this.numDS + "/" + this.numDM]);
    }
    else{
      //this._location.back();
      this.router.navigate(['home']);
    }
    
  }

  refeicaoDone() :void{
    this.hideCL = false;

    this.tmaService.arrRefeicoesDone.push({ idRefeicao: this.idRefeicao, numeroDS: this.numDS});
    setTimeout(() => {
      if(this.tmaService.qPagina === "cardapio"){
        this.router.navigate(['me/cardapio/' + this.meuIdDieta + "/" + this.numDS + "/" + this.numDM]);
      }
      else{
        console.log("should back");
        //this._location.back();
        this.router.navigate(['me/cardapio/' + this.meuIdDieta + "/" + this.numDS + "/" + this.numDM]);
      }
     
    }, 1000);
  }
}
